export enum COLORS {
  DIM_GREY = '#eee',
  BLUE = 'rgba(9, 122, 194, 1)',
  BLUE_MENU_PRIMARY = '#013281',
  BLUE_MENU_SECONDARY = 'rgba(0, 117, 201, 30%)',
  SHADOW_BLUE = 'rgba(9, 122, 194, 0.9)',
  GREY = '#6b787f',
  WHITE = '#fff',
  TEXT_BLACK = '#2B2727',
  LIGHT_GREY = '#8b8b8b',
  DEVIDER_GREY = '#f5f5f5',
  YELLOW = '#F9BE00',
  WHISPER = '#F5F6FA',
  PALE_SKY = '#6B787F',
  LIMED_SPURCE = '#333E48',
  JUNGLE_GREEN = '#2bae61',
  TEXT_BLUE = '#0073BA',
  SILVER = '#BDBDBD',
  SECONDARY_SILVER = '#CCCCCC',
  CHECKED = '#2bae61',
  NAVY = '#000e2c',
  MUSTARD = '#f2a900',
  SIDE_MENU_BLUE = 'rgba(1, 50, 129, 1)',
  SIDE_MENU_LIGHT_BLUE = 'rgba(1, 70, 151, 1)',
  SIDE_MENU_WHITE = 'rgba(255, 255, 255, 0.87)',
  SIDE_MENU_GREEN = 'rgba(161, 198, 13, 1)',
  SIDE_MENU_YELLOW = 'rgba(248, 195, 69, 1)',
  ACCORDION_BG_YELLOW = 'rgba(252, 183, 24, 0.1)',
  ACCORDION_BG_BLUE = 'rgba(8, 128, 188, 0.1)',
  ACCORDION_TEXT_BLACK = 'rgba(43, 39, 39, 1)',
  ACCORDION_TEXT_BLUE = 'rgba(0, 117, 201, 1)',
  ACCORDION_GRAY = 'rgba(139, 139, 139, 1)',
  FORM_INPUT_BORDER = 'rgba(232, 232, 232, 1)',
  FORM_INPUT_TEXT_GRAY = 'rgba(139, 139, 139, 1)',
  FORM_INPUT_BG_GRAY = '#F1F1F1',
  TABLE_HEADER_BG = 'rgba(248, 248, 248, 1)',
  DRAWER_BG_GRAY = '#F7F7F7',
  RED = 'red',
  GREEN = '#0EA800',
  LIGHT_GREY_TEXT = '#666666',
  LIGHT_ORANGE = '#FFF8E8',
  ORANGE_TEXT = '#C28C23',
  LIGHT_GREEN = '#76C2B6',
  PRIMARY_BUTTON_BLUE = '#0075C9',
  LIGHT_WHITE_GREY = '#D5DAE1',
  DARK_GRAY_TEXT = '#323e48',
}

export enum FONTS {
  THEME_FONT = 'Roboto',
}

export enum WIDTHS {
  DRAWER_WIDTH = 240,
}

export enum BUTTON_COLORS {
  PRIMARY_GOLDEN = '#f9be00',
  PRIMARY_BLUE = '#1175C9',
  SECONDARY = '#1175C9',
  PRIMARY_HOVER_GOLDEN = '#FFC912',
  GOLDEN_BUTTON_TITLE = '#333E48',
  BLUE_BUTTON_TITLE = '#FFFFFF',
  RED_BUTTON_TITLE = 'red',
}
export enum FONT_COLORS {
  DARK_GRAY = '#323e48',
  BLACK = '#000',
  PRIMARY_BLUE = '#0075C9',
  DARK_BLACK_GREY = '#464E58',
}
